export default __webpack_public_path__ + "static/media/bianka.ce2d1143.png";